<template>
    <!--Edit-->
    <div class="container">
        <div class="page-inner">
            <div class="page-header gp-admin-page-heading">
                <h3 class="fw-bold">Cobrança de sinistro</h3>
                <ul class="breadcrumbs">
                    <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                    <li class="separator"><i class="fa fa-chevron-right"></i></li>
                    <li class="nav-item"><a href="#" @click.prevent="$router.push('/listasinistroscobranca')">Cobranças de sinistros</a></li>
                    <li class="separator"><i class="fa fa-chevron-right"></i></li>
                    <li class="nav-item">Detalhe</li>
                </ul>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="Sinistro!=''">
                    <div class="card gp-collection-card">
                        <div class="card-body">
                            <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                <v-tab value="dados" class="tabinfo"
                                    style="font-size: 13px;text-transform: none !important;"><v-icon size="16">mdi-cash-sync</v-icon> Cobrança do sinistro</v-tab>
                            </v-tabs>
                            <v-window v-model="tab">
                                <v-window-item value="dados">
                                    <v-form>
                                        <v-container>
                                            <div class="row">
                                                <v-col cols="12" md="6">
                                                     <v-card style="padding: 15px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                 Informações Débito
                                                            </h5>
                                                        </div>
                                                         <v-row style="padding-top: 5px;padding-bottom: 5px;"  v-if="ListaSinistrosDebitoAndamento.length > 0">
                                                            <v-table style="background-color: transparent;font-size: 12px;">
                                                                <thead>
                                                                    <tr>
                                                                     <th style="width:40px">
                                                                        <!-- Selecionar todos -->
                                                                        <v-checkbox
                                                                        v-model="allSelected"
                                                                        density="compact"
                                                                        hide-details
                                                                        />
                                                                    </th>
                                                                    <th class="text-left">
                                                                            Origem
                                                                        </th>
                                                                    <th class="text-left">
                                                                            Sinistro
                                                                        </th>
                                                                        <th class="text-left">
                                                                            Descricão
                                                                        </th>
                                                                        <th class="text-left">
                                                                            Data Débito
                                                                        </th>
                                                                            <th class="text-left">
                                                                            Valor
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in ListaSinistrosDebitoAndamento"
                                                                        :key="index">
                                                                         <td>
                                                                            <v-checkbox
                                                                            v-model="item.marcado"
                                                                            density="compact"
                                                                            hide-details
                                                                            />
                                                                        </td>
                                                                        <td>{{ descricaoOrigemCobranca(item) }}</td>
                                                                        <td>{{ item.sntCodigo }}</td>
                                                                            <td>{{ item.sntDescricao }}</td>
                                                                        <td>{{ formattedDate(item.sdbDtDebito) }}</td>
                                                                        <td>{{ formatarValor(item.sdbValorDebito) }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </v-table>
                                                        </v-row>
                                                    </v-card>
                                                    <v-card style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Dados Cobrança
                                                            </h5>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Garantidora:</strong> {{ this.SinistroCobranca.garNome
                                                                }} - <strong>Imobiliária:</strong> {{ this.SinistroCobranca.imoNome
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cliente:</strong> {{ this.SinistroCobranca.pedDescricao
                                                                }} <v-icon @click="dialogCliente = true;">mdi-folder-open</v-icon>
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Data Inicial:</strong> {{
                                                                formattedDate(this.SinistroCobranca.sncDtInclusao) }}
                                                            </p>
                                                              <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Contratação:</strong>  {{ SinistroCobranca.pedId
                                                                }}
                                                            </p>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 18px; font-weight: 600;">
                                                                <strong>Situação Atual:</strong>  {{ SinistroCobranca.pedSituacaoPedido
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Vigência:</strong> {{  formattedDate(PedidoItem.pdiDataVigenciaIni) }} a  {{  formattedDate(PedidoItem.pdiDataVigenciaFim) }}
                                                            </p>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Produto:</strong> {{ PedidoItem.pdiNomeProduto }}
                                                            </p>
                                                        </div>
                                                    </v-card>
                                                     <v-card v-if="PedidosEndereco != ''" style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">Endereço
                                                                Contratação
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Endereço:</strong> {{
                                                                    PedidosEndereco[0].pdcEndereco
                                                                }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                    PedidosEndereco[0].pdcComplemento }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cidade/UF:</strong> {{
                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                {{ PedidosEndereco[0].pdcEstado }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Bairro:</strong> {{
                                                                    PedidosEndereco[0].pdcBairro
                                                                }} -  <strong>CEP:</strong> {{
                                                                    PedidosEndereco[0].pdcCep }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Tipo Imóvel:</strong> {{
                                                                    PedidosEndereco[0].pdcTipo
                                                                }} {{ PedidosEndereco[0].pdcResidencialTipo
                                                                }}
                                                            </p>
                                                        </div>
                                                    </v-card>
                                                    <div v-if="documentosSinistroDebitoTela.length" style="margin-top: 15px;">
                                                        <h5 class="subtitulo" style="font-size: 14px;">Documentos do Sinistro e Debitos</h5>
                                                        <v-table style="background-color: transparent;font-size: 12px;">
                                                            <thead>
                                                                <tr>
                                                                    <th>Origem</th>
                                                                    <th>Tipo</th>
                                                                    <th>Arquivo</th>
                                                                    <th>Referencia</th>
                                                                    <th>Download</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(doc, index) in documentosSinistroDebitoTela" :key="`${doc.origem}-${doc.id}-${index}`">
                                                                    <td>{{ doc.origem }}</td>
                                                                    <td>{{ doc.docNome }}</td>
                                                                    <td>{{ doc.nomeOriginal }}</td>
                                                                    <td>{{ doc.referencia }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="doc.nomeInterno" icon
                                                                            @click.prevent="VisualizarDocumento(doc.nomeInterno)"
                                                                            variant="text">
                                                                            <v-icon>mdi-download</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Download</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                     <button v-if="podeExonerar" :disabled="exonerando" type="button" class="btn btn-warning" style="color:#000000; margin-top: 15px;" @click="ExonerarContrato()">
                                                        Exonerar Garantia
                                                    </button>
                                                     <button v-if="podeEnviarAoJuridico" type="button" class="btn btn-black" style="color:#ffffff; margin-top: 15px; margin-left: 15px;" :disabled="enviandoExtratoJuridico" @click.prevent="dialogJuridicoDocs = true">
                                                        {{ enviandoExtratoJuridico ? 'Enviando...' : 'Enviar Extrato ao Juridico' }}
                                                    </button>
                                                    <div v-if="enviosJuridico.length" style="margin-top: 15px;">
                                                        <h5 class="subtitulo" style="font-size: 14px;">Envios ao Juridico</h5>
                                                        <v-table style="background-color: transparent;font-size: 12px;">
                                                            <thead>
                                                                <tr>
                                                                    <th>Data</th>
                                                                    <th>Destino</th>
                                                                    <th>Descricao</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in enviosJuridico" :key="item.shcId">
                                                                    <td>{{ formattedDateTime(item.shcDtInclusao) }}</td>
                                                                    <td>{{ item.shcPessoaContato }}</td>
                                                                    <td>{{ item.shcDescricao }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                      <v-card class="gp-debt-summary-card">
                                                        <h5 class="subtitulo"><v-icon size="17">mdi-cash-multiple</v-icon> Informações do débito</h5>
                                                        <div class="gp-debt-mode-row">
                                                            <div class="gp-debt-rates">
                                                                <span><small>Multa</small><strong>{{ parsePercent(SinistroConfiguracao.gscMulta) }}%</strong></span>
                                                                <span><small>Juros/dia</small><strong>{{ parsePercent(SinistroConfiguracao.gscJuroDiario) }}%</strong></span>
                                                            </div>
                                                            <v-switch v-model="usarCapitalizacaoDiaria" hide-details inset density="compact"
                                                                :label="usarCapitalizacaoDiaria ? 'Capitalização diária' : 'Juros simples (mora)'" />
                                                        </div>
                                                        <div class="gp-debt-values">
                                                            <div class="gp-debt-value-item"><small>Valor original</small><strong>{{ formatarValor(resumo.totalOriginal) }}</strong></div>
                                                            <div class="gp-debt-value-item"><small>Multa</small><strong>{{ formatarValor(resumo.totalMulta) }}</strong></div>
                                                            <div class="gp-debt-value-item"><small>Juros</small><strong>{{ formatarValor(resumo.totalJuros) }}</strong></div>
                                                        </div>
                                                        <div class="gp-debt-total-row">
                                                            <div class="gp-debt-date"><small>Atualizado em</small><strong>{{ $moment().format('DD/MM/YYYY') }}</strong></div>
                                                            <div class="gp-debt-total"><small>Valor total atualizado</small><strong>{{ formatarValor(resumo.totalFinal) }}</strong></div>
                                                        </div>
                                                      </v-card>
                                                        <v-container>
                                                         <v-row>
                                                                <div class="col-md-8 col-lg-8" style="margin-top: 20px;">
                                                                    <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                        Informações Cobrança
                                                                    </h5>
                                                                </div>
                                                                 <div class="col-md-4 col-lg-4" style="margin-top: 20px;text-align: right;">
                                                                    <button type="button" class="btn btn-black" style="color:#ffffff;" @click="InicioAcordo=!InicioAcordo;">
                                                                        {{ !InicioAcordo ? 'Simular Acordo': 'Cancelar Acordo'}}
                                                                    </button>
                                                                 </div>
                                                                <v-row v-if="!InicioAcordo" style="padding-top: 20px;">
                                                                    <div class="col-md-6 col-lg-6" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Pessoa Contato</label>
                                                                            <input v-model="SinistroCobrancaHistorico.shcPessoaContato" type="text"
                                                                                class="form-control" placeholder="Pessoa Contato" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-3 col-lg-3" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Data Contato</label>
                                                                            <input v-model="SinistroCobrancaHistorico.shcDtInclusao" type="date"
                                                                                class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-3 col-lg-3" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Próximo Contato</label>
                                                                            <input v-model="SinistroCobrancaHistorico.shcDtProximoContato" type="date"
                                                                                class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-12 col-lg-12" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Observações</label>
                                                                            <textarea cols="5" rows="5" style="width: 100%;" v-model="SinistroCobrancaHistorico.shcDescricao" class="form-control" maxlength="255"
                                                                                placeholder="Observações">
                                                                            </textarea>
                                                                        </div>
                                                                    </div>
                                                                    <v-col cols="12" md="9">
                                                                        <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                                                            PDF</label>
                                                                        <v-file-input v-model="selectedFileDebito"
                                                                            label="Selecione o arquivo" variant="underlined"
                                                                            prepend-icon="mdi-file"
                                                                            accept="image/*,application/pdf"></v-file-input>
                                                                    </v-col>
                                                                    <v-col cols="12" md="3">
                                                                        <button type="button" class="btn btn-info"
                                                                            @click.prevent="InserirDocumentoHistorico()"
                                                                            style="color:#ffffff;margin-top: 20px;">
                                                                            Inserir
                                                                        </button>
                                                                    </v-col>
                                                                    <v-row v-if="ListaSinistroDocumentoHistoricoTemp.length > 0">
                                                                        <v-table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-left">
                                                                                            Data
                                                                                        </th>
                                                                                        <th class="text-left">
                                                                                            Arquivo
                                                                                        </th>
                                                                                        <th class="text-left">
                                                                                            Visualização
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="(item, index) in ListaSinistroDocumentoHistoricoTemp"
                                                                                        :key="index">
                                                                                        <td>{{ formattedDate(item.scdDtInclusao) }}</td>
                                                                                        <td>{{ item.scdNomeOriginal }}</td>
                                                                                        <td style="text-align: center;">
                                                                                            <v-btn icon
                                                                                                @click.prevent="VisualizarDocumento(item.scdNomeInterno)"
                                                                                                variant="text">
                                                                                                <v-icon>mdi-file</v-icon>
                                                                                                <v-tooltip activator="parent"
                                                                                                    location="top">Visualizar</v-tooltip>
                                                                                            </v-btn>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                        </v-table>
                                                                    </v-row>
                                                                </v-row>
                                                                <v-row v-else style="padding-top: 20px;">
                                                                    <div class="col-md-4 col-lg-4" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Qtde Parcelas</label>
                                                                            <input v-model="Acordo.qtdeParcelas" type="number"
                                                                                class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-4 col-lg-4" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Primeiro Vencimento</label>
                                                                            <input v-model="Acordo.vencimento" type="date"
                                                                                class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <v-col cols="12" md="3" style="padding-top: 23px;">
                                                                        <button type="button" class="btn btn-info"
                                                                            @click.prevent="GerarParcelasAcordo()"
                                                                            style="color:#ffffff;margin-top: 20px;">
                                                                            Gerar Parcelas
                                                                        </button>
                                                                    </v-col>
                                                                    <!-- Tabela de parcelas geradas -->
                                                                    <v-col cols="12" md="12" style="padding-top: 23px;">
                                                                        <v-table v-if="ParcelasAcordo.length" class="mt-4" style="background:transparent;font-size:12px;">
                                                                        <thead>
                                                                            <tr>
                                                                            <th>#</th>
                                                                            <th>Vencimento</th>
                                                                            <th>Valor (R$)</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(parc, i) in ParcelasAcordo" :key="i">
                                                                                <td>{{ i + 1 }}</td>
                                                                                <td>
                                                                                    <input type="date" class="form-control" v-model="parc.vencimento" />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                    type="number" step="0.01" min="0"
                                                                                    class="form-control"
                                                                                    v-model.number="parc.valor"
                                                                                    @blur="onValorParcelaChange(i)"
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                        </v-table>
                                                                    </v-col>
                                                                    <v-col cols="12" md="12" style="padding-top: 10px;text-align: center;">
                                                                        <!-- Resumo dos valores -->
                                                                        <div v-if="ParcelasAcordo.length" class="mt-2">
                                                                            <div><strong>Valor com juros:</strong> {{ formatarValor(totalResumoTarget) }}</div>
                                                                            <div><strong>Total das parcelas:</strong> {{ formatarValor(totalParcelado) }}</div>
                                                                            <div :style="{color: diffValor === 0 ? '#16a34a' : '#b91c1c'}">
                                                                                <strong>{{ diffDescricao }}:</strong> {{ formatarValor(diffValorAbs) }}
                                                                            <v-btn
                                                                                size="x-small"
                                                                                @click="distribuirDiferencaParaFrente(0)">
                                                                                Distribuir
                                                                            </v-btn>
                                                                            </div>
                                                                        </div>
                                                                    </v-col>
                                                                    <div class="col-md-6 col-lg-6" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Pessoa Contato</label>
                                                                            <input v-model="SinistroCobrancaHistorico.shcPessoaContato" type="text"
                                                                                class="form-control" placeholder="Pessoa Contato" />
                                                                        </div>
                                                                    </div>
                                                                     <div class="col-md-12 col-lg-12" style="padding: 5px;">
                                                                        <div class="form-group">
                                                                            <label>Observações</label>
                                                                            <textarea cols="5" rows="5" style="width: 100%;" v-model="SinistroCobrancaHistorico.shcDescricao" class="form-control" maxlength="255"
                                                                                placeholder="Observações">
                                                                            </textarea>
                                                                        </div>
                                                                    </div>
                                                                    <v-col cols="12" md="12" style="padding-top: 23px;text-align: center;">
                                                                          <button type="button" class="btn btn-black" v-if="ParcelasAcordo.length > 0"
                                                                            :disabled="salvandoAcordo"
                                                                            @click.prevent="ConfirmaAcordo()"
                                                                            style="color:#ffffff;margin-top: 20px;">
                                                                              {{ salvandoAcordo ? 'Salvando...' : 'Confirmar Acordo' }}
                                                                        </button>
                                                                    </v-col>
                                                                </v-row>
                                                         </v-row>
                                                         <v-row v-if="!InicioAcordo">
                                                            <v-col cols="12" md="6">
                                                                <button type="button" class="btn btn-success" style="color:#ffffff;" @click="AddCobrancaHistorico()">
                                                                    Salvar
                                                                </button>
                                                            </v-col>
                                                         </v-row>
                                                         <v-row v-if="!InicioAcordo">
                                                               <v-card v-if="PedidosEndereco != ''" style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                                    <div>
                                                                        <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                            Histórico Cobranças
                                                                        </h5>
                                                                    </div>
                                                                    <v-table class="gp-collection-history-table" style="background-color: transparent;">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th class="text-left gp-history-register-column">
                                                                                        Registro
                                                                                    </th>
                                                                                    <th class="text-left gp-history-description-column">
                                                                                        Descrição
                                                                                    </th>
                                                                                    <th class="text-left">
                                                                                        Visualização
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr v-for="(item, index) in ListaSinistroCobrancaHist"
                                                                                    :key="index">
                                                                                    <td>
                                                                                        <div class="gp-history-register">
                                                                                            <strong>{{ formattedDate(item.shcDtInclusao) }}</strong>
                                                                                            <span><v-icon size="12">mdi-account-outline</v-icon>{{ item.shcPessoaContato || '—' }}</span>
                                                                                            <small><v-icon size="12">mdi-account-check-outline</v-icon>{{ item.cusNome || '—' }}</small>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td class="gp-history-description">{{ item.shcDescricao }}</td>
                                                                                    <td style="text-align: center;">
                                                                                        <v-btn v-for="docs in ListaSinistroDocumentoHistorico.filter(x=>x.shcId == item.shcId)" :key="docs.scdId" icon
                                                                                            @click.prevent="VisualizarDocumento(docs.scdNomeInterno)"
                                                                                            variant="text">
                                                                                            <v-icon>mdi-file</v-icon>
                                                                                            <v-tooltip activator="parent"
                                                                                                location="top">{{docs.scdNomeOriginal}}</v-tooltip>
                                                                                        </v-btn>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                    </v-table>
                                                               </v-card>
                                                         </v-row>
                                                        </v-container>
                                                </v-col>
                                            </div>
                                        </v-container>
                                    </v-form>
                                </v-window-item>
                            </v-window>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

     <!--modal Cliente-->
        <v-row justify="center">
            <v-dialog v-model="dialogCliente" class="controlcelEnd gp-collection-dialog" transition="dialog-bottom-transition" max-width="980">
                <v-card class="gp-dialog-card">
                    <v-card-title class="gp-dialog-title">
                        <span><v-icon size="19">mdi-account-details-outline</v-icon> Informações do cliente</span>
                        <button type="button" class="gp-dialog-close" title="Fechar" @click.prevent="dialogCliente = false"><v-icon size="18">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-dialog-content">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col v-if="Cliente != ''" cols="12" md="6"
                                        style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeEmpresa }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF/CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliDocumento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliRazaoSocial }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Responsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliResponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliCampoExtra1 }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefone }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsapp }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmail }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimento) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivil }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-if="Endereco != ''" cols="12" md="6">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                <span style="font-weight: 500;">Endereço Alternativo: </span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleEndereco }} - {{ Endereco.cleNumero }} - {{
                                                    Endereco.cleComplemento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Cidade/UF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCidade }} / {{ Endereco.cleEstado }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Bairro: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleBairro }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CEP: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCep }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfConjuge && Cliente.cliCpfConjuge != '' && Cliente.cliCpfConjuge != null"
                                        cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Conjuge: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoConjuge) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto1"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfCorresponsavel && Cliente.cliCpfCorresponsavel != '' && Cliente.cliCpfCorresponsavel != null"
                                        cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Corresponsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoCorresponsavel)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivilCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Pai: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomePaiCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeMaeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto2"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="gp-dialog-actions">
                        <v-spacer></v-spacer>
                        <button type="button" class="gp-dialog-secondary" @click.prevent="dialogCliente = false">Fechar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

     <!--modal Juridico Docs-->
        <v-row justify="center">
            <v-dialog v-model="dialogJuridicoDocs" class="controlcelEnd gp-collection-dialog" transition="dialog-bottom-transition" max-width="920">
                <v-card class="gp-dialog-card">
                    <v-card-title class="gp-dialog-title">
                        <span><v-icon size="19">mdi-file-document-multiple-outline</v-icon> Documentos complementares</span>
                        <button type="button" class="gp-dialog-close" title="Fechar" @click.prevent="dialogJuridicoDocs = false"><v-icon size="18">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-dialog-content">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <label>Selecione o Tipo</label>
                                        <select v-model="DocSelected"
                                            class="form-select form-control">
                                            <option :value=null>Selecione</option>
                                            <option v-for="optionTipo in ListaSinistroDocJuridico"
                                                :key="optionTipo.docId" :value="optionTipo">{{
                                                    optionTipo.docNome }}</option>
                                        </select>
                                    </v-col>
                                    <v-col cols="12" md="5">
                                        <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                            PDF</label>
                                        <v-file-input v-model="selectedFile"
                                            label="Selecione o arquivo" variant="underlined"
                                            prepend-icon="mdi-file"
                                            accept="image/*,application/pdf"></v-file-input>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                            <button type="button" class="btn btn-info"
                                            @click.prevent="SalvarDocumento()"
                                            style="color:#ffffff;margin-top: 20px;">
                                            Inserir
                                        </button>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-table>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Tipo
                                                </th>
                                                <th class="text-left">
                                                    Documento
                                                </th>
                                                <th class="text-left">
                                                    Visualização
                                                </th>
                                                <th>
                                                    Ações
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in ListaSinistroDocumentos"
                                                :key="index">
                                                <td>{{ item.docNome }}</td>
                                                <td>{{ item.sndNomeOriginal }}</td>
                                                <td style="text-align: center;">
                                                    <v-btn v-if="item.sndNomeInterno != ''" icon
                                                        @click.prevent="VisualizarDocumento(item.sndNomeInterno)"
                                                        variant="text">
                                                        <v-icon>mdi-file-eye</v-icon>
                                                        <v-tooltip activator="parent"
                                                            location="top">Visualizar</v-tooltip>
                                                    </v-btn>
                                                </td>
                                                <td>
                                                    <v-btn icon v-if="SinistroCobranca.pspId != 18"
                                                        @click.prevent="DeleteDocumento(item, index)"
                                                        variant="text">
                                                        <v-icon>mdi-delete-forever-outline</v-icon>
                                                        <v-tooltip activator="parent"
                                                            location="top">Excluir</v-tooltip>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </v-row>
                                <v-row>
                                     <div v-if="documentosJuridicoPendentes.length" style="font-size: 13px;color:#b91c1c;margin-top: 10px;">
                                        Documentos pendentes: {{ documentosJuridicoPendentes.map(x => x.docNome).join(', ') }}
                                     </div>
                                     <button v-if="podeEnviarAoJuridico" type="button" class="btn btn-black" style="color:#ffffff; margin-top: 15px; margin-left: 15px;" :disabled="!documentosJuridicoObrigatoriosOk || enviandoExtratoJuridico" @click="VerExtrato()">
                                        {{ enviandoExtratoJuridico ? 'Enviando...' : 'Enviar Extrato ao Juridico' }}
                                    </button>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="gp-dialog-actions">
                        <v-spacer></v-spacer>
                        <button type="button" class="gp-dialog-secondary" @click.prevent="dialogJuridicoDocs = false">Fechar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

</template>

<script>
import axios from 'axios'
import { personalizarEmailGarantidora } from '../../utils/guarantorEmail'
import EasyDataTable from 'vue3-easy-data-table'
import moment from 'moment'
import { useRoute } from 'vue-router'

export default {
  name: 'SinistroCobrancaDetalheView',
  components: {
    EasyDataTable,
    moment
  },
  setup () {
    const route = useRoute()
    const id = route.params.id
    return {
      id
    }
  },
  data: () => ({
    tab: null,
    User: {
      garid: 0,
      tpeid: 0,
      pesid: 0,
      cusid: 0
    },
    searchValue: '',
    MostraGrid: true,
    headers: [],
    SinistroCobranca: {},
    // pedidoendereco
    PedidosEndereco: [],
    PedidoItem: [],
    // documentos
    selectedFileDebito: '',
    ListaSinistrosDebitoAndamento: [],
    ListaSinistroDebitoDocumentos: [],
    TotalSinistroDebitoAndamento: 0,
    SinistroCobrancaHistorico: {
      shcId: 0,
      SncId: 0,
      shcDtInclusao: null,
      shcDtProximoContato: null,
      shcPessoaContato: '',
      shcDescricao: '',
      cusId: null
    },
    ListaSinistroCobrancaHist: [],
    SinistroDocumentoHistorico: {
      scdId: 0,
      cusId: null,
      scdDtInclusao: null,
      scdNomeOriginal: '',
      scdNomeInterno: '',
      docId: null,
      shcId: null
    },
    ListaSinistroDocumentoHistorico: [],
    ListaSinistroDocumentoHistoricoTemp: [],
    Cliente: {},
    Endereco: [],
    dialogCliente: false,
    SinistroConfiguracao: [],
    podeExonerar: false,
    podeEnviarAoJuridico: false,
    exonerando: false,
    usarCapitalizacaoDiaria: true,
    // Acordo
    InicioAcordo: false,
    Acordo: {
      qtdeParcelas: 0,
      vencimento: null
    },
    ParcelasAcordo: [],
    salvandoAcordo: false,
    // juridico docs
    dialogJuridicoDocs: false,
    ListaSinistroDocJuridico: [],
    DocSelected: null,
    selectedFile: '',
    ListaSinistroDocumentos: [],
    ListaSinistroDocumentosIniciais: [],
    ListaSinistroPagamentoDocumentos: [],
    enviandoExtratoJuridico: false
  }),
  methods: {
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    preprocessData (data) {
      return data.map(item => {
        return {
          ...item,
          proOrdem: parseInt(item.proOrdem)
        }
      })
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formattedDateTime (value) {
      if (value != null && value !== '') {
        return this.$moment(value).format('DD/MM/YYYY HH:mm')
      }
      return ''
    },
    parsePercent (v) {
      if (v == null) return 0
      const n = Number(String(v).replace(',', '.'))
      return isNaN(n) ? 0 : n // 2 -> 2%, 0.2 -> 0,2%
    },
    parseDateFlexible (input) {
      if (!input) return null
      const s = String(input).trim()
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        const [Y, M, D] = s.split('-').map(Number)
        return new Date(Y, M - 1, D)
      }
      const iso = s.replace(' ', 'T')
      const d = new Date(iso)
      if (!isNaN(d)) return new Date(d.getFullYear(), d.getMonth(), d.getDate())
      return null
    },
    hojeSemHora () {
      const now = new Date()
      return new Date(now.getFullYear(), now.getMonth(), now.getDate())
    },
    diffDays (a, b) {
      if (!a || !b) return 0
      const MS = 24 * 60 * 60 * 1000
      return Math.floor((b - a) / MS)
    },
    formatarValor (v) {
      const n = Number(v) || 0
      return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    descricaoOrigemCobranca (item) {
      return item?.origemCobranca === 'ACORDO_CANCELADO' ? 'Acordo cancelado' : 'Sinistro'
    },
    async UploadImg (value) {
      const formData = new FormData()
      formData.append('file', value)
      const uploadResult = await axios.post('/Telas/SinistroCobrancaDetalhe/upload', formData)
      return uploadResult
    },
    buildFileUrl (path) {
      if (!path) return ''
      const rel = String(path).replace(/\\/g, '/') // normaliza separadores
      const base = this.$imgURL
      return `${base}/Telas/SinistroCobrancaDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}`
    },
    openInNewTab (path) {
      const url = this.buildFileUrl(path)
      if (!url) return
      window.open(url, '_blank', 'noopener,noreferrer') // nova aba
    },
    VisualizarDocumento (item) {
      if (item) {
        this.openInNewTab(item)
      }
    },
    escapeHtml (value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
    },
    nomeArquivoSeguro (nome, fallback) {
      const raw = String(nome || fallback || 'documento.pdf').trim()
      return raw.replace(/[\\/:*?"<>|]+/g, '-')
    },
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(String(reader.result || '').split(',')[1] || '')
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    async carregarAnexoEmail (doc) {
      if (!doc?.path) return null
      const url = this.buildFileUrl(doc.path)
      const response = await axios.get(url, { responseType: 'blob' })
      const blob = response.data
      if (!blob) return null
      return {
        origem: doc.origem,
        nomeOriginal: doc.nomeOriginal,
        nomeAnexo: this.nomeArquivoSeguro(doc.nomeAnexo, doc.nomeOriginal),
        tipoAnexo: blob.type || 'application/octet-stream',
        tamanho: blob.size || 0,
        anexo: await this.blobToBase64(blob)
      }
    },
    montarDocumentosJuridico () {
      const docs = []
      const add = (origem, nomeOriginal, nomeInterno, docNome, ref) => {
        if (!nomeInterno) return
        if (docs.some(x => x.path === nomeInterno)) return
        docs.push({
          origem,
          nomeOriginal: nomeOriginal || docNome || 'Documento',
          nomeAnexo: `${origem} - ${nomeOriginal || docNome || ref || 'documento'}`,
          path: nomeInterno,
          docNome,
          ref
        })
      };

      (this.ListaSinistroDocumentosIniciais || []).forEach(x => add('Documento inicial', x.sndNomeOriginal, x.sndNomeInterno, x.docNome, x.sntId));
      (this.ListaSinistroDocumentos || []).forEach(x => add('Envio juridico', x.sndNomeOriginal, x.sndNomeInterno, x.docNome, x.sntId));
      (this.ListaSinistroDocumentoHistorico || []).forEach(x => add('Historico cobranca', x.scdNomeOriginal, x.scdNomeInterno, x.docNome, x.shcId));
      (this.ListaSinistroPagamentoDocumentos || []).forEach(x => add('Comprovante pagamento', x.spdNomeOriginal, x.spdNomeInterno, x.docNome, x.snpId));
      (this.ListaSinistrosDebitoAndamento || []).forEach(deb => {
        (this.ListaSinistroDebitoDocumentos || [])
          .filter(x => x.sdbId === deb.sdbId)
          .forEach(x => add('Documento debito', x.sddNomeOriginal, x.sddNomeInterno, x.docNome, deb.sdbId))
      })

      return docs
    },
    montarLinhasDebitosEmail () {
      return (this.ListaSinistrosDebitoAndamento || []).map(item => {
        const valorAtualizado = this.calcularValorAtualizadoDebito(item)
        return `<tr>
                    <td>${this.escapeHtml(this.formattedDate(item.sdbDtDebito))}</td>
                    <td>${this.escapeHtml(item.sntDescricao || item.docNome || this.descricaoOrigemCobranca(item))}</td>
                    <td>${this.escapeHtml(item.sntCodigo || '')}</td>
                    <td style="text-align:right;">${this.escapeHtml(this.formatarValor(item.sdbValorDebito))}</td>
                    <td style="text-align:right;">${this.escapeHtml(this.formatarValor(valorAtualizado))}</td>
                </tr>`
      }).join('')
    },
    calcularEncargosDebito (item, hoje) {
      const principal = Number(item?.sdbValorDebito) || 0
      if (item?.isentoEncargos === true) return { principal, multa: 0, juros: 0 }
      const multa = principal * (this.parsePercent(this.SinistroConfiguracao?.gscMulta) / 100)
      const taxaDia = this.parsePercent(this.SinistroConfiguracao?.gscJuroDiario) / 100
      const dias = Math.max(0, this.diffDays(this.parseDateFlexible(item?.sdbDtDebito), hoje))
      const juros = this.usarCapitalizacaoDiaria
        ? (principal + multa) * (Math.pow(1 + taxaDia, dias) - 1)
        : principal * taxaDia * dias
      return { principal, multa, juros: Math.max(0, juros) }
    },
    calcularValorAtualizadoDebito (item) {
      const { principal, multa, juros } = this.calcularEncargosDebito(item, this.hojeSemHora())
      return principal + multa + juros
    },
    montarHtmlEmailJuridico (documentos, parte, totalPartes) {
      const endereco = this.Endereco || {}
      const docsRows = documentos.map(x => `<tr>
                <td>${this.escapeHtml(x.origem)}</td>
                <td>${this.escapeHtml(x.nomeOriginal)}</td>
                <td>${this.escapeHtml(x.nomeAnexo)}</td>
            </tr>`).join('')
      const totalAtualizado = (this.ListaSinistrosDebitoAndamento || []).reduce((acc, item) => acc + this.calcularValorAtualizadoDebito(item), 0)
      const complementoParte = totalPartes > 1 ? `<p><strong>Parte:</strong> ${parte}/${totalPartes}</p>` : ''

      return `
                <p><strong>Garantidora:</strong> ${this.escapeHtml(this.SinistroCobranca.garNome)}</p>
                <p><strong>Imobiliaria:</strong> ${this.escapeHtml(this.SinistroCobranca.imoNome)}</p>
                <p><strong>Cliente:</strong> ${this.escapeHtml(this.SinistroCobranca.cliNome)} - CPF/CNPJ: ${this.escapeHtml(this.Cliente?.cliDocumento || '')}</p>
                <h3>Endereco Contratacao</h3>
                <p><strong>Endereco:</strong> ${this.escapeHtml(endereco.pdcEndereco)}${endereco.pdcNumero ? ', ' + this.escapeHtml(endereco.pdcNumero) : ''} ${this.escapeHtml(endereco.pdcComplemento || '')}</p>
                <p><strong>Cidade/UF:</strong> ${this.escapeHtml(endereco.pdcCidade)} / ${this.escapeHtml(endereco.pdcEstado)}</p>
                <p><strong>Bairro:</strong> ${this.escapeHtml(endereco.pdcBairro)} - <strong>CEP:</strong> ${this.escapeHtml(endereco.pdcCep)}</p>
                <p><strong>Tipo Imovel:</strong> ${this.escapeHtml(endereco.pdcTipo)} ${this.escapeHtml(endereco.pdcResidencialTipo || '')}</p>
                <h3>Atualizacao dos Valores (${this.$moment().format('DD/MM/YYYY')})</h3>
                ${complementoParte}
                <table class="document-table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Descricao</th>
                            <th>Sinistro</th>
                            <th>Valor</th>
                            <th>Valor atualizado</th>
                        </tr>
                    </thead>
                    <tbody>${this.montarLinhasDebitosEmail()}</tbody>
                </table>
                <p><strong>TOTAL ATUALIZADO:</strong> ${this.escapeHtml(this.formatarValor(totalAtualizado))}</p>
                <h3>Anexos enviados ${totalPartes > 1 ? `(parte ${parte}/${totalPartes})` : ''}</h3>
                <table class="document-table">
                    <thead>
                        <tr>
                            <th>Origem</th>
                            <th>Documento</th>
                            <th>Arquivo anexo</th>
                        </tr>
                    </thead>
                    <tbody>${docsRows || '<tr><td colspan="3">Sem anexos nesta parte.</td></tr>'}</tbody>
                </table>`
    },
    dividirAnexosPorTamanho (anexos) {
      const limite = 20 * 1024 * 1024
      const partes = []
      let atual = []
      let tamanhoAtual = 0

      anexos.forEach(anexo => {
        if (atual.length && tamanhoAtual + anexo.tamanho > limite) {
          partes.push(atual)
          atual = []
          tamanhoAtual = 0
        }
        atual.push(anexo)
        tamanhoAtual += anexo.tamanho
      })

      if (atual.length || !partes.length) partes.push(atual)
      return partes
    },
    // enderecoPedido
    async SelecionarEnderecoPedido () {
      this.PedidosEndereco = []
      await axios.get('/Telas/SinistroCobrancaDetalhe/GetAllByPedIdEndereco/' + this.SinistroCobranca.pedId)
        .then(response => {
          this.PedidosEndereco = response.data
          // console.log('PedidosEndereco')
          // console.log(this.PedidosEndereco)
        })
        .catch(error => {
          console.error(error)
        })
    },
    async AddCobrancaHistorico () {
      if (this.SinistroCobrancaHistorico.shcPessoaContato == '' || this.SinistroCobrancaHistorico.shcPessoaContato == null) { return this.$mensagemAviso('Preencha pessoa contato.') }
      if (this.SinistroCobrancaHistorico.shcDescricao == '' || this.SinistroCobrancaHistorico.shcDescricao == null) { return this.$mensagemAviso('Preencha alguma observação.') }
      if (this.SinistroCobrancaHistorico.shcDtInclusao == '' || this.SinistroCobrancaHistorico.shcDtInclusao == null) { return this.$mensagemAviso('Preencha data da cobrança.') }

      this.SinistroCobrancaHistorico.cusId = this.User.cusid
      this.SinistroCobrancaHistorico.sncId = this.SinistroCobranca.sncId
      this.SinistroCobrancaHistorico.shcDtInclusao = moment(this.SinistroCobrancaHistorico.shcDtInclusao).format('YYYY-MM-DDTHH:mm:ss')
      if (this.SinistroCobrancaHistorico.shcDtProximoContato != '' && this.SinistroCobrancaHistorico.shcDtProximoContato) {
        this.SinistroCobrancaHistorico.SncDtProximoContato = moment(this.SinistroCobrancaHistorico.shcDtProximoContato).format('YYYY-MM-DDTHH:mm:ss')
      }

      const resp = await axios.post('/Telas/SinistroCobrancaDetalhe/AddSinistroCobrancaHistorico', this.SinistroCobrancaHistorico)
      const novoIdShcId = resp.data

      // verifica se tem documentos
      if (novoIdShcId > 0) {
        const dt = moment().format('YYYY-MM-DDTHH:mm:ss')
        // salva documentos SEQUENCIALMENTE (um por vez)
        for (const [i, element] of (this.ListaSinistroDocumentoHistoricoTemp.filter(x => x.scdId == 0) || []).entries()) {
          const payload = {
            scdId: 0,
            shcId: novoIdShcId,
            cusId: this.User?.cusid ?? this.User?.cusId,
            scdDtInclusao: dt,
            scdNomeOriginal: element.scdNomeOriginal,
            scdNomeInterno: element.scdNomeInterno,
            docId: element.docId
          }

          const resp2 = await axios.post('/Telas/SinistroCobrancaDetalhe/AddSinistroCobrancaHistoricoDocumento', payload)

          // pode vir número puro ou objeto { sndId: ... }
          const novoId = (resp2?.data && typeof resp2.data === 'object') ? resp2.data.scdId : resp2?.data

          if (novoId > 0) {
            if (this.$set) this.$set(this.ListaSinistroDocumentoHistoricoTemp[i], 'scdId', novoId) // Vue 2
            else this.ListaSinistroDocumentoHistoricoTemp[i].scdId = novoId // Vue 3
          } else {
            console.warn('Falha ao salvar documento', element, resp?.data)
          }
        }
        this.SinistroCobrancaHistorico = {
          shcId: 0,
          SncId: 0,
          shcDtInclusao: null,
          shcDtProximoContato: null,
          shcPessoaContato: '',
          shcDescricao: '',
          cusId: null
        }
        this.ListaSinistroDocumentoHistoricoTemp = []
        this.Get()
      }
    },
    async InserirDocumentoHistorico () {
      if (this.selectedFileDebito == '' || this.selectedFileDebito == null) {
        this.$mensagemAviso('Selecione um Documento a ser enviado.')
      } else {
        try {
          const uploadSuccess = await this.UploadImg(this.selectedFileDebito[0])

          if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
            this.SinistroDocumentoHistorico.scdNomeOriginal = this.selectedFileDebito[0].name
            this.SinistroDocumentoHistorico.scdNomeInterno = uploadSuccess.data.nameFile
            this.SinistroDocumentoHistorico.scdDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss')
            this.SinistroDocumentoHistorico.cusId = this.User.cusid
            this.SinistroDocumentoHistorico.docId = 6
            this.SinistroDocumentoHistorico.docNome = 'Anexo Cobranca'
            this.SinistroDocumentoHistorico.shcId = 0

            // Adiciona cópia do documento à lista
            this.ListaSinistroDocumentoHistoricoTemp.push({ ...this.SinistroDocumentoHistorico })
            // console.log('this.ListaSinistroDebitoDocumentos')
            // console.log(this.ListaSinistroDebitoDocumentos)

            // Limpa seleções
            this.selectedFileDebito = ''
            this.SinistroDocumentoHistorico = {
              scdId: 0,
              cusId: null,
              scdDtInclusao: null,
              scdNomeOriginal: '',
              scdNomeInterno: '',
              docId: null,
              shcId: 0
            }
          } else {
            this.$mensagemErro('Erro inesperado ao processar o arquivo. Tente novamente.')
          }
        } catch (error) {
          // Trata erro retornado pelo backend (ex: BadRequest)
          const mensagem = error.response?.data || 'Erro ao enviar o documento.'
          this.$mensagemErro(mensagem)
        }
      }
    },
    // Acordo
    GerarParcelasAcordo () {
      const n = Number(this.Acordo.qtdeParcelas) || 0
      const primeiro = this.Acordo.vencimento
      const total = this.totalResumoTarget

      if (!n || n < 1) return alert('Informe a quantidade de parcelas (>=1).')
      if (!primeiro) return alert('Informe o primeiro vencimento.')
      if (!total || total <= 0) return alert('Total do resumo é zero.')

      const baseDate = this.toDate(primeiro)
      if (!baseDate) return alert('Data inválida.')

      const totalC = this.toCents(total)
      const baseC = Math.floor(totalC / n)
      let resto = totalC - baseC * n // qtos centavos sobraram

      const parcelas = []
      for (let i = 0; i < n; i++) {
        const venc = this.addDays(baseDate, i * 30)
        // adiciona +1 centavo nas primeiras "resto" parcelas
        const valorC = baseC + (resto > 0 ? 1 : 0)
        if (resto > 0) resto--

        parcelas.push({
          valor: this.fromCents(valorC),
          vencimento: this.toISODate(venc)
        })
      }
      this.ParcelasAcordo = parcelas
    },
    onValorParcelaChange (editedIndex) {
      // começa a distribuir a partir da próxima parcela
      this.distribuirDiferencaParaFrente(editedIndex + 1)
    },
    distribuirDiferencaParaFrente (startIndex = 0) {
      if (!this.ParcelasAcordo.length || startIndex >= this.ParcelasAcordo.length) return

      // diferença em centavos entre o alvo e o somatório atual
      let diffC = this.toCents(this.totalResumoTarget) - this.toCents(this.totalParcelado)

      if (diffC === 0) return

      // percorre só do startIndex até o fim
      const n = this.ParcelasAcordo.length

      // segurança para evitar loop longo
      let guard = 200000 // 2 mil reais em centavos, por exemplo
      while (diffC !== 0 && guard-- > 0) {
        for (let i = startIndex; i < n && diffC !== 0; i++) {
          const atualC = this.toCents(this.ParcelasAcordo[i].valor)

          if (diffC > 0) { // falta distribuir (somar)
            this.ParcelasAcordo[i].valor = this.fromCents(atualC + 1)
            diffC -= 1
          } else { // sobrou (subtrair)
            if (atualC > 0) {
              this.ParcelasAcordo[i].valor = this.fromCents(atualC - 1)
              diffC += 1
            }
          }
        }
        // Se estamos tentando subtrair e todas as parcelas à frente viraram 0,
        // não há de onde tirar — saímos e deixamos a diferença remanescente.
        if (diffC < 0 && this.ParcelasAcordo.slice(startIndex).every(p => this.toCents(p.valor) === 0)) break
      }
    },
    async ConfirmaAcordo () {
      if (this.salvandoAcordo) return
      const itensSelecionados = this.ListaSinistrosDebitoAndamento.filter(x => x.marcado)
      if (!itensSelecionados.length) {
        return this.$mensagemAviso('Selecione ao menos um item para o acordo.')
      }
      if (!this.SinistroCobrancaHistorico.shcPessoaContato) {
        return this.$mensagemAviso('Preencha pessoa contato.')
      }
      if (!this.SinistroCobrancaHistorico.shcDescricao) {
        return this.$mensagemAviso('Preencha alguma observação.')
      }

      const result = await this.$mensagemConfirma('Confirma a criação de acordo para os sinistro selecionados?')
      if (!result?.isConfirmed) return

      try {
        this.salvandoAcordo = true
        this.SinistroCobrancaHistorico.cusId = this.User.cusid
        this.SinistroCobrancaHistorico.sncId = this.SinistroCobranca.sncId
        this.SinistroCobrancaHistorico.shcDtInclusao = this.$moment().format('YYYY-MM-DDTHH:mm:ss')

        const { data: novoIdShcId } = await axios.post(
          '/Telas/SinistroCobrancaDetalhe/AddSinistroCobrancaHistorico',
          this.SinistroCobrancaHistorico
        )

        if (!novoIdShcId || novoIdShcId <= 0) {
          return this.$mensagemAviso('Não foi possível criar o histórico do sinistro.')
        }

        if (!this.ParcelasAcordo?.length) {
          return this.$mensagemAviso('Defina ao menos uma parcela para o acordo.')
        }

        const dadosAcordo = {
          snaId: 0,
          shcId: novoIdShcId,
          snaDtInclusao: this.$moment().format('YYYY-MM-DDTHH:mm:ss'),
          snaValorOriginal: this.resumo.totalOriginal,
          snaValorAcordo: this.totalParcelado,
          snaValorMulta: this.resumo.totalMulta,
          snaValorMora: this.resumo.totalJuros,
          snaQtdeParcela: this.ParcelasAcordo.length,
          snaDtPrimeiroVencimento: this.$moment(this.ParcelasAcordo[0].vencimento).format('YYYY-MM-DDTHH:mm:ss'),
          listParcelamentos: this.ParcelasAcordo,
          listSinSinistroDebitos: itensSelecionados,
          sinistroConfiguracao: this.SinistroConfiguracao,
          todosSinistros: this.ListaSinistrosDebitoAndamento.filter(x => !x.marcado).length,
          pedId: this.SinistroCobranca.pedId
        }

        const { data: resp2 } = await axios.post(
          '/Telas/SinistroCobrancaDetalhe/AddSinistroDadosAcordo',
          dadosAcordo
        )

        // console.log('resp2', resp2);
        this.$mensagemSucesso('Acordo criado com sucesso.')
        this.$router.push('/listasinistrosacordo')
      } catch (err) {
        console.error(err)
        this.$mensagemErro('Falha ao criar o acordo. Tente novamente.')
      } finally {
        this.salvandoAcordo = false
      }
    },
    // Helpers
    toCents (v) { return Math.round((Number(v) || 0) * 100) },
    fromCents (c) { return +(c / 100).toFixed(2) },

    toDate (iso) {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso))
      if (!m) return null
      const d = new Date(+m[1], +m[2] - 1, +m[3])
      return isNaN(d) ? null : d
    },
    toISODate (d) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    addDays (d, days) {
      const x = new Date(d.getFullYear(), d.getMonth(), d.getDate())
      x.setDate(x.getDate() + days)
      return x
    },
    // Acordo
    async ExonerarContrato () {
      if (!this.podeExonerar || this.exonerando) return
      this.exonerando = true
      let confirmado = false
      try {
        const result = await this.$mensagemConfirma('Exonerar a garantia, zerar as parcelas em aberto com vencimento a partir de hoje e avisar o inquilino?')
        if (!result?.isConfirmed) return
        confirmado = true
        const { data } = await axios.put('/Telas/SinistroCobrancaDetalhe/ExonerarGarantia/' + this.SinistroCobranca.pedId)
        if (data?.exonerado !== true) throw new Error('A API não confirmou a exoneração.')
        this.podeExonerar = false
        try {
          await this.EnviaAvisoExoneracaoInquilino()
        } catch (e) {
          this.$mensagemErro('Garantia exonerada. Não foi possível confirmar o encaminhamento do e-mail ao inquilino.')
          return
        }
        try {
          await axios.post('/Telas/SinistroCobrancaDetalhe/AddSinistroCobrancaHistorico', {
            cusId: this.User.cusid, sncId: this.SinistroCobranca.sncId,
            shcDtInclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
            shcDescricao: 'Garantia exonerada. Aviso ao inquilino encaminhado para envio por e-mail.',
            shcPessoaContato: this.SinistroCobranca.cliEmail
          })
        } catch (e) {
          this.$mensagemErro('Garantia exonerada e aviso encaminhado, mas não foi possível registrar o aviso no histórico.')
          return
        }
        this.$mensagemSucesso('Garantia exonerada e aviso ao inquilino encaminhado para envio.')
      } catch (e) {
        this.$mensagemErro(e.response?.data?.message || 'Não foi possível confirmar a exoneração. Nenhum aviso foi solicitado.')
      } finally {
        if (confirmado) await this.Get()
        this.exonerando = false
      }
    },
    async EnviaAvisoExoneracaoInquilino () {
      const { data } = await axios.get(`/Telas/SinistroCobrancaDetalhe/GetByIdMensagemPadrao/27?garId=${this.SinistroCobranca.garId || 0}`)
      this.templateEmail = data
      const _texto = 'Contratação de Garantia Exonerada'
      const _dadosEmail = {
        nomeDe: this.SinistroCobranca.garNome,
        nomePara: this.SinistroCobranca.cliNome,
        assunto: 'Exoneração de Garantia Locatícia: ' + this.SinistroCobranca.cliNome,
        destinatario: this.SinistroCobranca.cliEmail,
        emailResposta: this.SinistroCobranca.garEmail,
        textoEmail: this.templateEmail.mpdTexto.replace('[CodPedido]', this.SinistroCobranca.pedId)
          .replace('[NovoStatus]', _texto)
          .replace('[TextoResumo]', '')
          .replace('[TextoObs]', ''),
        listAnexos: null
      }
      const emailPersonalizado = await personalizarEmailGarantidora(_dadosEmail, this.SinistroCobranca.garId || this.User.garid || 0, this.$imgURL, this.$GarantePayLinkAcesso, this.$GarantePayEmail)
      if (!emailPersonalizado) throw new Error('Não foi possível preparar o aviso.')
      const envio = await axios.post('/Telas/SinistroCobrancaDetalhe/Enviamail', emailPersonalizado)
      if (envio.data !== 1) throw new Error('Encaminhamento não confirmado.')
    },
    async VerExtrato () {
      if (!this.podeEnviarAoJuridico || this.enviandoExtratoJuridico) return

      const emailJuridico = this.SinistroConfiguracao?.gscEmailJuridico
      if (!emailJuridico) {
        return this.$mensagemAviso('E-mail juridico nao cadastrado na configuracao de sinistro da garantidora.')
      }
      if (!this.documentosJuridicoObrigatoriosOk) {
        return this.$mensagemAviso('Inclua os documentos obrigatorios de Envio Juridico antes de enviar o extrato.')
      }

      const result = await this.$mensagemConfirma('Enviar extrato atualizado e documentos do processo para o juridico?')
      if (!result?.isConfirmed) return

      try {
        this.enviandoExtratoJuridico = true

        const documentos = this.montarDocumentosJuridico()
        const anexos = []
        for (const doc of documentos) {
          const anexo = await this.carregarAnexoEmail(doc)
          if (anexo) anexos.push(anexo)
        }

        const partes = this.dividirAnexosPorTamanho(anexos)
        const totalPartes = partes.length

        for (let index = 0; index < partes.length; index++) {
          const parte = index + 1
          const anexosParte = partes[index]
          const assuntoParte = totalPartes > 1 ? ` - Parte ${parte}/${totalPartes}` : ''
          const assunto = `Extrato juridico sinistro pedido ${this.SinistroCobranca.pedId}${assuntoParte}`
          const textoEmail = this.montarHtmlEmailJuridico(anexosParte, parte, totalPartes)

          await axios.post('/Telas/SinistroCobrancaDetalhe/Enviamail', {
            garId: this.SinistroCobranca.garId || this.User.garid || null,
            nomeDe: this.SinistroCobranca.garNome,
            nomePara: 'Juridico',
            assunto,
            destinatario: emailJuridico,
            emailResposta: this.SinistroCobranca.garEmail,
            textoEmail,
            listAnexos: anexosParte.map(x => ({
              nomeAnexo: x.nomeAnexo,
              anexo: x.anexo,
              tipoAnexo: x.tipoAnexo
            }))
          })

          const historico = {
            shcId: 0,
            sncId: this.SinistroCobranca.sncId,
            shcDtInclusao: this.$moment().format('YYYY-MM-DDTHH:mm:ss'),
            shcDtProximoContato: null,
            shcPessoaContato: emailJuridico,
            shcDescricao: `Envio ao juridico - Extrato atualizado parte ${parte}/${totalPartes} com ${anexosParte.length} anexo(s).`,
            cusId: this.User.cusid
          }

          const { data: novoId } = await axios.post('/Telas/SinistroCobrancaDetalhe/AddSinistroCobrancaHistorico', historico)
          this.ListaSinistroCobrancaHist.push({ ...historico, shcId: novoId })
        }

        this.$mensagemSucesso('Extrato enviado ao juridico.')
      } catch (err) {
        console.error(err)
        this.$mensagemErro('Falha ao enviar extrato ao juridico.')
      } finally {
        this.enviandoExtratoJuridico = false
      }
    },
    async SalvarDocumento () {
      if (this.DocSelected == '' || this.DocSelected == null) {
        this.$mensagemAviso('Selecione o Tipo de Documento a ser enviado.')
      } else if (this.selectedFile == '' || this.selectedFile == null) {
        this.$mensagemAviso('Selecione um Documento a ser enviado.')
      } else {
        try {
          const file = Array.isArray(this.selectedFile) ? this.selectedFile[0] : this.selectedFile
          const sntId = this.sntIdDocumentoJuridico
          if (!sntId) {
            return this.$mensagemAviso('Nao foi possivel identificar o sinistro para vincular o documento.')
          }

          const uploadSuccess = await this.UploadImg(file)
          const dt = moment().format('YYYY-MM-DDTHH:mm:ss')
          if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
            const payload = {
              sndId: 0,
              sntId,
              cusId: this.User?.cusid ?? this.User?.cusId,
              sndDtInclusao: dt,
              sndNomeOriginal: file.name,
              sndNomeInterno: uploadSuccess.data.nameFile,
              docId: this.DocSelected.docId
            }

            const { data: novoId } = await axios.post('/Telas/SinistroCobrancaDetalhe/AddSinistroDocumento', payload)
            const item = {
              ...payload,
              sndId: novoId,
              docNome: this.DocSelected.docNome
            }
            this.ListaSinistroDocumentos.push(item)
            this.ListaSinistroDocumentosIniciais.push(item)
            this.DocSelected = null
            this.selectedFile = ''
            this.$mensagemSucesso('Documento incluido.')
          } else {
            this.$mensagemErro('Erro inesperado ao processar o arquivo. Tente novamente.')
          }
        } catch (error) {
          const mensagem = error.response?.data || 'Erro ao enviar o documento.'
          this.$mensagemErro(mensagem)
        }
      }
    },
    DeleteDocumento (item, index) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            if (item.sndId == 0) {
              this.ListaSinistroDocumentos.splice(index, 1)
            } else {
              const cliam1 = item.sndId
              axios.delete(`/Telas/SinistroCobrancaDetalhe/DeleteSinistroDocumento/${cliam1}`)
                .then(response => {
                  if (response.status == 200) {
                    this.$mensagemAvisoSucesso('Registro Excluido.')
                    this.ListaSinistroDocumentos.splice(index, 1)
                    this.ListaSinistroDocumentosIniciais = this.ListaSinistroDocumentosIniciais.filter(x => x.sndId !== item.sndId)
                  }
                })
            }
          }
        })
    },
    async Get () {
      this.podeExonerar = false
      this.podeEnviarAoJuridico = false
      let _id = ''
      if (this.id != '') {
        _id = this.id
      }
      await axios.get('/Telas/SinistroCobrancaDetalhe/GetDados/' + _id)
        .then(response => {
          const d = response?.data ?? {}
          this.podeExonerar = d.podeExonerar === true
          this.podeEnviarAoJuridico = d.podeEnviarAoJuridico === true
          const first = a => (Array.isArray(a) && a.length) ? a[0] : null
          const asArr = v => Array.isArray(v) ? v : []
          const toNum = v => (v == null || v === '') ? 0 : Number(String(v).replace(/\./g, '').replace(',', '.')) || 0
          const sumBy = (list, selector) => asArr(list).reduce((acc, item) => acc + (selector(item) || 0), 0)

          // ───────── Atribuições seguras ─────────
          this.User.tpeid = d.tpeId ?? null
          this.User.garid = d.garId ?? null
          this.User.cusid = d.cusId ?? null
          this.User.pesid = d.pesId ?? null
          this.SinistroCobranca = first(d.sinistroCobranca) ?? {}
          this.PedidoItem = first(d.pedidoItem) ?? {}
          this.ListaSinistrosDebitoAndamento = asArr(d.sinistroDebitoAndamento)
            .filter(it => it.sdbAprovado === true || it.sdbAprovado === 1 || it.sdbAprovado === 'true')
            .map(it => ({
              ...it,
              marcado: true
            }))
          this.TotalSinistroDebitoAndamento = sumBy(this.ListaSinistrosDebitoAndamento, i => (i.sdbValorDebito))
          this.ListaSinistroCobrancaHist = asArr(d.sinistroCobrancaHistorico)
          const shcIdsPagina = new Set(this.ListaSinistroCobrancaHist.map(x => x.shcId))
          const sdbIdsPagina = new Set(this.ListaSinistrosDebitoAndamento.map(x => x.sdbId))
          this.ListaSinistroDocumentoHistorico = asArr(d.sinistroCobrancaHistoricoDocs).filter(x => shcIdsPagina.has(x.shcId))
          this.ListaSinistroDebitoDocumentos = asArr(d.sinistroDebitoDocumento).filter(x => sdbIdsPagina.has(x.sdbId))
          this.ListaSinistroDocumentosIniciais = asArr(d.sinistroDocumento)
          this.ListaSinistroPagamentoDocumentos = asArr(d.sinistroPagamentoDocumento)
          this.Cliente = d.cliente
          this.Endereco = first(d.clienteEndereco) ?? {}
          this.SinistroConfiguracao = first(d.sinistroConfiguracao) ?? {}
          this.ListaSinistroDocJuridico = asArr(d.documentosSinistroJuridico)
          const docsJuridicoIds = new Set(this.ListaSinistroDocJuridico.map(x => x.docId))
          this.ListaSinistroDocumentos = this.ListaSinistroDocumentosIniciais.filter(x => docsJuridicoIds.has(x.docId))
          // console.log('this.SinistroConfiguracao')
          // console.log(this.SinistroConfiguracao)

          // Chama só no final (se depender dos dados acima)
          if (this.SinistroCobranca != '') {
            this.SelecionarEnderecoPedido?.()
          }

          // console.log('this.SinistroCobranca')
          // console.log(this.SinistroCobranca)
          // console.log('this.ListaSinistroCobrancaHist')
          // console.log(this.ListaSinistroCobrancaHist)
          //    console.log('this.ListaSinistroDocumentoHistorico')
          // console.log(this.ListaSinistroDocumentoHistorico)
        })
        .catch(err => {
          console.error('Erro ao buscar dados do sinistro:', err)
          // Defaults seguros em caso de erro

          this.SinistroCobranca = {}
          this.ListaSinistrosDebitoAndamento = []
          this.ListaSinistroDebitoDocumentos = []
          this.ListaSinistroDocumentosIniciais = []
          this.ListaSinistroPagamentoDocumentos = []
          this.TotalSinistroDebitoAndamento = 0
        })
    }
  },
  created () {
    this.Get()
  },
  computed: {
    allSelected: {
      get () {
        const arr = this.ListaSinistrosDebitoAndamento || []
        return arr.length > 0 && arr.every(x => !!x.marcado)
      },
      set (val) {
        (this.ListaSinistrosDebitoAndamento || []).forEach(x => x.marcado = !!val)
      }
    },
    selecionados () {
      return (this.ListaSinistrosDebitoAndamento || []).filter(x => !!x.marcado)
    },
    enviosJuridico () {
      return (this.ListaSinistroCobrancaHist || [])
        .filter(x => String(x.shcDescricao || '').toLowerCase().includes('envio ao juridico'))
        .sort((a, b) => new Date(b.shcDtInclusao || 0) - new Date(a.shcDtInclusao || 0))
    },
    sntIdDocumentoJuridico () {
      const debito = (this.ListaSinistrosDebitoAndamento || []).find(x => x.sntId > 0)
      return debito?.sntId || this.SinistroCobranca?.sntId || 0
    },
    documentosJuridicoPendentes () {
      const enviados = new Set((this.ListaSinistroDocumentos || [])
        .filter(x => x.sndNomeInterno)
        .map(x => x.docId))
      return (this.ListaSinistroDocJuridico || []).filter(x => !enviados.has(x.docId))
    },
    documentosJuridicoObrigatoriosOk () {
      return (this.ListaSinistroDocJuridico || []).length > 0 && this.documentosJuridicoPendentes.length === 0
    },
    documentosSinistroDebitoTela () {
      const docsSinistro = (this.ListaSinistroDocumentosIniciais || []).map(x => ({
        id: x.sndId,
        origem: 'Sinistro',
        docNome: x.docNome,
        nomeOriginal: x.sndNomeOriginal,
        nomeInterno: x.sndNomeInterno,
        referencia: x.sntId ? `Sinistro ${x.sntId}` : ''
      }))

      const docsDebito = (this.ListaSinistroDebitoDocumentos || []).map(x => {
        const debito = (this.ListaSinistrosDebitoAndamento || []).find(d => d.sdbId === x.sdbId)
        return {
          id: x.sddId,
          origem: 'Debito',
          docNome: x.docNome,
          nomeOriginal: x.sddNomeOriginal,
          nomeInterno: x.sddNomeInterno,
          referencia: debito?.sntCodigo ? `Sinistro ${debito.sntCodigo}` : (x.sdbId ? `Debito ${x.sdbId}` : '')
        }
      })

      return [...docsSinistro, ...docsDebito].filter(x => x.nomeInterno)
    },
    resumo () {
      let totalOriginal = 0
      let totalMulta = 0
      let totalJuros = 0
      const hoje = this.hojeSemHora()
      for (const item of this.selecionados) {
        const { principal, multa, juros } = this.calcularEncargosDebito(item, hoje)
        totalOriginal += principal
        totalMulta += multa
        totalJuros += juros
      }
      const totalFinal = totalOriginal + totalMulta + totalJuros
      return { totalOriginal, totalMulta, totalJuros, totalFinal }
    },
    totalResumoTarget () {
      // ajuste se seu resumo está noutro local/nome
      return Number(this.resumo?.totalFinal) || 0
    },
    totalParcelado () {
      return (this.ParcelasAcordo || []).reduce((acc, p) => acc + (Number(p.valor) || 0), 0)
    },
    diffValor () {
      // diferença que falta/sobra entre o alvo e o somatório digitado
      const diff = +(this.totalParcelado - this.totalResumoTarget).toFixed(2)
      return diff
    },
    diffValorAbs () {
      return Math.abs(this.diffValor)
    },
    diffDescricao () {
      if (this.diffValor > 0) return 'Diferenca a mais'
      if (this.diffValor < 0) return 'Diferenca a menos'
      return 'Sem diferenca'
    }
  }
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}

.fontaprova {
    font-size: 16px;
    font-weight: 600;
}
.gp-collection-card { overflow: hidden; border: 1px solid #e1d9cd; border-radius: 14px; background: #fff; }
.gp-collection-card > .card-body { padding: 0; }
.gp-collection-card :deep(.gp-client-tabs) { padding: 8px 14px 0; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; }
.gp-collection-card :deep(.v-tab) { gap: 6px; }
.gp-collection-card :deep(.v-window-item > .v-form > .v-container) { max-width: none; padding: 16px; }
.gp-collection-card :deep(.v-card) { padding: 15px !important; border: 1px solid #e1d9cd !important; border-radius: 12px !important; background: #fff !important; color: #4d586d !important; box-shadow: none !important; }
.gp-collection-card :deep(.v-col > .v-card + .v-card) { margin-top: 12px !important; }
.gp-collection-card :deep(.subtitulo) { display: flex; align-items: center; min-height: 38px; margin: -15px -15px 14px !important; padding: 11px 15px !important; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; color: #102a5a; font-size: 13px !important; font-weight: 800; }
.gp-collection-card :deep(.texto-mensagem) { margin-bottom: 7px !important; color: #4d586d !important; font-size: 11.5px !important; line-height: 1.45; }
.gp-collection-card :deep(.v-table) { overflow: hidden; margin: 10px 0; border: 1px solid #e8e1d7; border-radius: 10px; background: #fff !important; font-size: 10.5px !important; }
.gp-collection-card :deep(.v-table th) { background: #f1ede7; color: #42506a; font-size: 9px; font-weight: 800; text-transform: uppercase; }
.gp-collection-card :deep(.v-table td) { border-color: #eee7dd; }
.gp-collection-card :deep(.v-field) { border-radius: 9px; background: #fff; font-size: 12px; }
.gp-collection-card :deep(textarea) { min-height: 88px; resize: vertical; border: 1px solid #d8d2c8; border-radius: 9px; font-size: 12px; }
.gp-collection-card :deep(.btn) { min-height: 34px; padding: 7px 13px; border: 0; border-radius: 9px; font-size: 11px; font-weight: 700; box-shadow: none; }
.gp-collection-card :deep(.btn-info),
.gp-collection-card :deep(.btn-success) { background: #3fa7f5; color: #fff !important; }
.gp-collection-card :deep(.btn-black) { background: #102a5a; color: #fff !important; }
.gp-collection-card :deep(.btn-warning) { background: #e77900; color: #fff !important; }
.gp-collection-card :deep(.v-switch) { color: #102a5a; }
.gp-collection-card :deep(.gp-debt-summary-card) { padding: 15px !important; background: linear-gradient(145deg,#fff 0%,#fbfcff 100%) !important; }
.gp-debt-summary-card .subtitulo .v-icon { margin-right: 7px; color: #d96f00; }
.gp-debt-mode-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding-bottom: 12px; border-bottom: 1px solid #e8e1d7; }
.gp-debt-rates { display: flex; flex-wrap: wrap; gap: 8px; }
.gp-debt-rates span { display: flex; align-items: center; gap: 5px; padding: 6px 9px; border-radius: 8px; background: #f2f5fa; }
.gp-debt-rates small,.gp-debt-value-item small,.gp-debt-date small,.gp-debt-total small { color: #788397; font-size: 9.5px; font-weight: 700; }
.gp-debt-rates strong { color: #102a5a; font-size: 11px; }
.gp-debt-mode-row :deep(.v-switch) { flex: 0 0 auto; }
.gp-debt-mode-row :deep(.v-label) { color: #5f6b80; font-size: 10px !important; }
.gp-debt-values { display: grid; grid-template-columns: 1.4fr 1fr 1fr; gap: 9px; padding: 13px 0; }
.gp-debt-value-item { display: flex; min-width: 0; flex-direction: column; gap: 4px; padding: 10px 11px; border: 1px solid #e8e1d7; border-radius: 9px; background: #fff; }
.gp-debt-value-item strong { color: #263b62; font-size: 15px; font-weight: 750; white-space: nowrap; }
.gp-debt-total-row { display: flex; align-items: stretch; justify-content: space-between; gap: 10px; }
.gp-debt-date { display: flex; min-width: 125px; flex-direction: column; justify-content: center; gap: 3px; padding: 8px 10px; border-radius: 9px; background: #f7f4ef; }
.gp-debt-date strong { color: #34425a; font-size: 12px; }
.gp-debt-total { display: flex; flex: 1; align-items: flex-end; flex-direction: column; justify-content: center; padding: 10px 13px; border-radius: 10px; background: #102a5a; }
.gp-debt-total small { color: #b9c9e8; }
.gp-debt-total strong { color: #fff; font-size: 20px; font-weight: 800; }
.gp-collection-history-table :deep(table) { table-layout: fixed; width: 100%; }
.gp-collection-history-table :deep(.gp-history-register-column) { width: 31%; }
.gp-collection-history-table :deep(.gp-history-description-column) { width: 57%; }
.gp-collection-history-table :deep(th:last-child) { width: 12%; text-align: center !important; }
.gp-history-register { display: flex; flex-direction: column; gap: 3px; line-height: 1.25; }
.gp-history-register strong { color: #102a5a; font-size: 10px; }
.gp-history-register span,.gp-history-register small { display: flex; align-items: flex-start; gap: 4px; color: #566178; font-size: 9.5px; white-space: normal; word-break: break-word; }
.gp-history-register small { color: #7b8597; }
.gp-history-register .v-icon { flex: 0 0 auto; margin-top: 1px; color: #d96f00; }
.gp-history-description { color: #354158; line-height: 1.45; white-space: normal !important; word-break: break-word; }
.gp-collection-dialog :deep(.v-overlay__content) { width: calc(100% - 28px); }
.gp-dialog-card { overflow: hidden; border: 1px solid #e1d9cd !important; border-radius: 14px !important; background: #fff !important; box-shadow: 0 18px 50px rgba(16,42,90,.18) !important; }
.gp-dialog-title { display: flex; align-items: center; justify-content: space-between; min-height: 56px; padding: 13px 18px !important; border-bottom: 1px solid #e8e1d7; background: #fcfaf7 !important; color: #102a5a; }
.gp-dialog-title > span { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 800; }
.gp-dialog-title :deep(.v-icon) { color: #d96f00; }
.gp-dialog-close { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #ddd6cc; border-radius: 9px; background: #fff; color: #677386; transition: .18s ease; }
.gp-dialog-close:hover { border-color: #e77900; color: #c96500; }
.gp-dialog-content { max-height: 70vh; overflow-y: auto; padding: 16px 18px !important; color: #4d586d; }
.gp-dialog-content :deep(.v-container) { max-width: none; padding: 0; }
.gp-dialog-content :deep(.v-row) { margin: -6px; }
.gp-dialog-content :deep(.v-col) { padding: 6px; font-size: 11.5px; }
.gp-dialog-content :deep(.v-col[style*="border-right"]) { border-right-color: #e8e1d7 !important; }
.gp-dialog-content :deep(label) { display: block; margin-bottom: 5px; color: #3d485c; font-size: 10.5px; font-weight: 700; }
.gp-dialog-content :deep(.form-control), .gp-dialog-content :deep(.form-select), .gp-dialog-content :deep(.v-field) { min-height: 35px; border-radius: 9px; font-size: 11.5px; }
.gp-dialog-content :deep(.v-table) { overflow: hidden; margin-top: 10px; border: 1px solid #e8e1d7; border-radius: 10px; font-size: 10.5px; }
.gp-dialog-content :deep(.v-table th) { background: #f1ede7; color: #42506a; font-size: 9px; font-weight: 800; text-transform: uppercase; }
.gp-dialog-content :deep(.btn) { min-height: 34px; padding: 7px 13px; border: 0; border-radius: 9px; font-size: 11px; font-weight: 700; }
.gp-dialog-actions { min-height: 58px; padding: 11px 18px !important; border-top: 1px solid #e8e1d7; background: #fcfaf7; }
.gp-dialog-secondary { min-width: 92px; min-height: 34px; padding: 7px 14px; border: 1px solid #9ba4b0; border-radius: 9px; background: #fff; color: #4f5b6d; font-size: 11px; font-weight: 700; }
.gp-dialog-secondary:hover { border-color: #102a5a; color: #102a5a; }
@media(max-width:767.98px){
    .gp-collection-card :deep(.v-window-item > .v-form > .v-container){padding:10px}
    .gp-collection-card :deep(.v-card){padding:13px!important}
    .gp-collection-card :deep(.subtitulo){margin:-13px -13px 12px!important}
    .gp-collection-card :deep(.btn){width:100%;margin:6px 0!important}
    .gp-dialog-title{padding:11px 13px!important}
    .gp-dialog-content{max-height:72vh;padding:12px!important}
    .gp-dialog-content :deep(.v-col[style*="border-right"]){border-right:0!important}
    .gp-dialog-actions{padding:10px 12px!important}
    .gp-dialog-secondary{width:100%}
    .gp-debt-mode-row{align-items:flex-start;flex-direction:column}
    .gp-debt-values{grid-template-columns:1fr}
    .gp-debt-total-row{flex-direction:column}
    .gp-debt-total{align-items:flex-start}
}
</style>
